import * as lx from "@shared/lingxi/core";
import { registerModuleClicks } from "@shared/lingxi/kit";
import "@shared/dom-polyfills/dataset";

registerModuleClicks(require("./lingxi.json"));
main();

function getClosedCookie() {
  const value = (document.cookie.match(/\bbottom-cover-closed=([^;,]*)[;,]?\b/) || [])[1];
  return value !== undefined && value !== "false" && value !== "0";
}

function setClosedCookie(newChecked) {
  document.cookie =
    "bottom-cover-closed=" +
    (newChecked ? "true" : "false") +
    ";" +
    document.cookie.replace(/\s*\bbottom-cover-closed=[^;,]*[;,]?\b\s*/g, "");
}

function onSwiChanged(e) {
  const newChecked = e.currentTarget.checked;
  if (!newChecked) moduleViewCover();
  setClosedCookie(newChecked);
}

function moduleViewCover() {
  lx.moduleView("b_airbnb_pc_bottom_cover_mv");
}

function main() {
  const swi = window.document.getElementById("switch--miniapp-cover");
  swi.checked = getClosedCookie();
  swi.disabled = false;
  if (swi.dataset.abParam) {
    lx.abtest(swi.dataset.abKey, swi.dataset.abParam);
  }
  if (!swi.checked) {
    moduleViewCover();
  }

  swi.addEventListener("change", onSwiChanged);
}
